export var InviteJoinState;
(function (InviteJoinState) {
    InviteJoinState["INVITE_VALID_AUTH_REQUIRED"] = "INVITE_VALID_AUTH_REQUIRED";
    InviteJoinState["INVITE_VALID_READY_TO_JOIN"] = "INVITE_VALID_READY_TO_JOIN";
    InviteJoinState["JOINED_APPROVED"] = "JOINED_APPROVED";
    InviteJoinState["JOINED_PENDING_APPROVAL"] = "JOINED_PENDING_APPROVAL";
    InviteJoinState["JOIN_REJECTED"] = "JOIN_REJECTED";
    InviteJoinState["JOIN_REJECTED_CAN_REAPPLY"] = "JOIN_REJECTED_CAN_REAPPLY";
    InviteJoinState["INVITE_EXPIRED_OR_INVALID"] = "INVITE_EXPIRED_OR_INVALID";
    InviteJoinState["BLOCKED_ALREADY_IN_OTHER_ORG"] = "BLOCKED_ALREADY_IN_OTHER_ORG";
})(InviteJoinState || (InviteJoinState = {}));
//# sourceMappingURL=invite-join-state.enum.js.map